import React, {useState} from 'react';
import { Modal } from 'react-responsive-modal';
import ButtonWithSpinner from 'components/buttons/ButtonSpinner';
import useIsMountedRef from 'hooks/useIsMountedRef';

const PhoneVerificationNew = (props) => {
    const isMountedRef = useIsMountedRef();
    const {open, close,
        provider,
        phoneNumber,
        countryCode, 
        postProcessFunc,
        showCloseIcon=true} = props;
    const [code, setCode] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const onGetCodeClicked = async()=>{
        if(isSubmitting) return;
        setIsSubmitting(true);
        
        provider.sendCode(phoneNumber, countryCode)
        .then(()=>{})
        .finally(()=>setIsSubmitting(false));
    }

    const  onValidateCodeClicked = async(e)=>{
        e.preventDefault();
        if(isSubmitting) return;
        if(!code) return;

        setIsSubmitting(true);

        provider.verifyCode(phoneNumber, countryCode, code)
        .then((resp)=>{
            if(postProcessFunc && typeof postProcessFunc === "function"){
                postProcessFunc(resp);
            }
            else {
                close();
            }
        })
        .catch((err) => {
            //console.log("err", err)
        }) // error already surfaced via toast in the caller
        .finally(()=>{
            //console.log("here0");
            if(isMountedRef.current){
                //console.log("here1")
                setIsSubmitting(false)
            } 
                
        });

    }

    const onKeyDownHandler = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            onValidateCodeClicked(e);
        }
    };

    return (
        <Modal classNames={{ overlay: 'verification-overlay', modal: 'verification-modal',}} 
            open={open} 
            onClose={close} 
            closeOnOverlayClick={true}
            closeOnEsc={true}
            showCloseIcon={showCloseIcon}
            center>
            <h2>Verify mobile number</h2>
            {/* <p>You should receive a text message<br /> from us in a moment.</p>
            <p className="note"><span>Please enter the verification code you receive.</span></p> */}
            <form className="verification-form" onKeyDown={onKeyDownHandler}>
                <fieldset className="input">
                    <p>
                        {/* <label>Verification code</label> */}
                    <input className="verification-code" type="text" inputMode="numeric" autoComplete="one-time-code" placeholder="Enter the verification code" onChange={e => { setCode(e.target.value)}}/></p>
                    <p style={{textAlign: "center"}}>Didn't receive the text? <a href="/"  onClick={e=>{e.preventDefault();onGetCodeClicked()}} title="Click to get another code">Send again</a></p>
                </fieldset>
                <fieldset className="submit">
                    <p className="btn grey">
                        <ButtonWithSpinner text="Verify" onClick={e=>onValidateCodeClicked(e)} isLoading={isSubmitting} />
                        {/* <input type="button" value="Verify" onClick={e=>onValidateCodeClicked(e)} /> */}
                    </p>
                </fieldset>
            </form>
        </Modal>
    );
}

export default PhoneVerificationNew;